module.exports = __webpack_public_path__ + "static/media/9.32c0a271.jpg";